import { computed, defineComponent } from '@vue/composition-api';
import FetchData from '@/components/DataProvider/FetchData.vue';
import Card from '@/components/Card/Card.vue';
import IconSpinner from '@/components/Icon/icons/IconSpinner.vue';
import { useRouteQuery } from '@/composables';
import { FILTER_DEBOUNCE } from '@/constants/filters';
import isEmpty from 'lodash.isempty';
import { mapQueryToApiV2 } from '@/util/query';
import { TablePagination } from '@/views/_components/Table';
export default defineComponent({
    components: {
        FetchData,
        IconSpinner,
        Card,
        TablePagination,
    },
    setup(_, ctx) {
        const { routeQuery } = useRouteQuery(ctx);
        const computedQuery = computed(() => {
            const query = mapQueryToApiV2({
                ...routeQuery.value,
                brandId: ctx.root.$route.params.id,
            });
            if (routeQuery.value.centralCostId) {
                query.distinct = true;
            }
            return query;
        });
        return {
            computedQuery,
            FILTER_DEBOUNCE,
            isEmpty,
        };
    },
});
